import angular from 'angular';

import PlansComponent from './plans.cmpt';
import ComponentModule from './component';

export default angular
    .module('common.plans', [
        ComponentModule.name
    ])
    .component(PlansComponent.selector, PlansComponent);



// WEBPACK FOOTER //
// ./src/common/component/plans/index.js